var app = angular.module('leonardo');

var CustomPortfolioSearchFilter = function () {
  return function (items, searchTerm) {
    if (searchTerm) {
      let newSearchTerm = searchTerm.toString().toUpperCase();
      return items.filter(item => {
        return lookForNestedObject(item, newSearchTerm);
      })
    }
    else { return items; }
    
    function lookForNestedObject(item, newSearchTerm) {
      let copyItem = Object.assign({}, item);
      function searchNested(obj, path = "") {
        for (let key in obj) {
          const currentPath = path ? `${path}.${key}` : key;
          const value = obj[key];
          if (typeof value === 'string' && value.toUpperCase().includes(newSearchTerm)) {
            return true;
          } else if (typeof value === 'object' && value !== null) {
            if (searchNested(value, currentPath)) {
              return true;
            }
          }
        }
        return false;
      }
      return searchNested(copyItem);
    }
  };
};
app.filter('CustomPortfolioSearch', [CustomPortfolioSearchFilter]);
